jQuery.feature_import("js-form-dirty-formless",
  () => require("./form-dirty.js"),
  mod => mod.feature_js_form_dirty_formless
);
jQuery.feature_import("js-form-dirty",
  () => require("./form-dirty.js"),
  mod => mod.feature_js_form_dirty
);